import { Flex, Tooltip } from '@chakra-ui/react';
import { GenericSubmissionField } from 'src/components/Submission/MySubmission/FormFieldGeneric/GenericSubmissionField';
import SubmissionFiles from '../../../../components/Assessment/SubmissionFiles';
import { useAdjudicationData } from 'src/contexts/AdjudicationDataProvider';
import AdjudicationInvitation from 'src/components/Adjudications/Invitation';
import { Badge } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faFileLines } from '@fortawesome/pro-light-svg-icons';
import { faDiagramSubtask, faLanguage } from '@fortawesome/pro-regular-svg-icons';

export const SubmissionDetails = () => {
  const { fieldsResponse, adjudication } = useAdjudicationData();
  const { articleTypeName, fields } = fieldsResponse;
  const isInviteAccepted = adjudication.workflow.currentState === 'invited';
  const isDoubleAnonymous = fields['DoubleAnonymousPeerReview']?.value;
  const articleSubType = fields['ArticleSubtype']?.value as string | undefined;
  const articleLanguage = fields['ArticleLanguage']?.value as string | undefined;

  return (
    <Flex flexDirection="column" gap={6}>
      <Flex gap={4}>
        {articleTypeName && (
          <Badge variant="attention" size="context">
            <Flex gap={1} alignItems="center">
              <FontAwesomeIcon icon={faFileLines} />
              {articleTypeName}
            </Flex>
          </Badge>
        )}
        {articleSubType && (
          <Tooltip
            hasArrow
            placement="bottom"
            label={`Article Sub Type`}
            borderRadius={4}
            shouldWrapChildren
          >
            <Badge variant="interactive" size="context">
              <Flex gap={1} alignItems="center">
                <FontAwesomeIcon icon={faDiagramSubtask} />
                {articleSubType}
              </Flex>
            </Badge>
          </Tooltip>
        )}
        {articleLanguage && (
          <Tooltip
            hasArrow
            placement="bottom"
            label={`Article Language`}
            borderRadius={4}
            shouldWrapChildren
          >
            <Badge variant="success" size="context">
              <Flex gap={1} alignItems="center">
                <FontAwesomeIcon icon={faLanguage} />
                {articleLanguage}
              </Flex>
            </Badge>
          </Tooltip>
        )}
        {isDoubleAnonymous !== undefined && (
          <Badge variant="neutral" size="context">
            <Flex gap={1} alignItems="center">
              <FontAwesomeIcon icon={isDoubleAnonymous ? faEyeSlash : faEye} />
              {isDoubleAnonymous ? 'Double Anonymous' : 'Single Anonymous'}
            </Flex>
          </Badge>
        )}
      </Flex>
      <GenericSubmissionField entryPoint="adjudication" fieldName="Title" />
      <GenericSubmissionField
        entryPoint="adjudication"
        fieldName="EnglishTitle"
      />
      <GenericSubmissionField entryPoint="adjudication" fieldName="Subtitle" />
      <GenericSubmissionField
        entryPoint="adjudication"
        fieldName="EnglishSubtitle"
      />
      {isInviteAccepted && <AdjudicationInvitation />}
      <GenericSubmissionField entryPoint="adjudication" fieldName="Abstract" />
      <GenericSubmissionField
        entryPoint="adjudication"
        fieldName="EnglishAbstract"
      />
      <GenericSubmissionField entryPoint="adjudication" fieldName="Keywords" />
      <GenericSubmissionField entryPoint="adjudication" fieldName="SubmissionGuidelines" />
      <GenericSubmissionField
        entryPoint="adjudication"
        fieldName="EnglishKeywords"
      />
      <GenericSubmissionField
        entryPoint="adjudication"
        fieldName="ArticleSubtype"
      />
      <GenericSubmissionField
        entryPoint="adjudication"
        fieldName="ArticleLanguage"
      />

      {fieldsResponse.fields['Supplementary']?.value ||
      fieldsResponse.fields['Manuscript']?.value ||
      fieldsResponse.fields['AnonymizedManuscript']?.value ||
      fieldsResponse.fields['Figures']?.value ||
      fieldsResponse.fields['Tables']?.value ? (
        <SubmissionFiles entryPoint="adjudication" />
      ) : null}
      <GenericSubmissionField
        entryPoint="adjudication"
        fieldName="NumberOfFigures"
      />
      <GenericSubmissionField
        entryPoint="adjudication"
        fieldName="NumberOfColorFigures"
      />
      <GenericSubmissionField
        entryPoint="adjudication"
        fieldName="NumberOfTables"
      />
      <GenericSubmissionField
        entryPoint="adjudication"
        fieldName="NumberOfWords"
      />
      <GenericSubmissionField
        entryPoint="adjudication"
        fieldName="GeneralClassifications"  
        />
    </Flex>
  );
};
